const focusableElementsSelector =
    'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';

const focusableFormElementsSelector =
    'input:not([type="button"]), textarea, select, [tabindex]:not([tabindex="-1"])';

/**
 * Returns focusable elements that are not disabled.
 * @param {HTMLElement} container - DOM element we will check the descendants of.
 */
export function getFocusableElements(container) {
    if (!container) return;

    return Array.from(
        container.querySelectorAll(focusableElementsSelector)
    ).filter(el => !el.hasAttribute('disabled'));
}

/**
 * Returns focusable non-button form elements that are not disabled.
 * @param {HTMLElement} container - DOM element we will check the descendants of.
 */
export function getFocusableFormElements(container) {
    if (!container) return;

    return Array.from(
        container.querySelectorAll(focusableFormElementsSelector)
    ).filter(
        el =>
            !el.hasAttribute('disabled') &&
            el.tagName?.toLowerCase() !== 'button' &&
            el.getAttribute('role')?.toLowerCase() !== 'button' &&
            // The legacy Button component has tab-index of 0, which gets selected by the selector.
            // Double check that we don't accidentally return one of those buttons.
            // We should remove this once the Mezzanine buttons are built.
            el.getAttribute('id') !== 'modal-primary-button' &&
            el.getAttribute('id') !== 'modal-secondary-button'
    );
}
